export default "__VITE_ASSET__Dgo_qnR7__"